import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { BillTotal, CalculateTaxForCommonTax, MainBillTotal } from "../../../CommonFunction/CalculateGST/CalculateTax";
import { Addition, Subtraction } from "../../../CommonFunction/CalculationsWithDecimalValues";
import { SalesBillFormulaTable } from "../FormComponents/AddLMSSalesBill/RelatedTables/SalesBillFormulaTable";
import Input from "../Input/Input";
import { getBookingTotalAmount, getCNTotalAmount, getItemAmount, getTotalForFreightBill } from "./RelatedFunctions";
import InputWithDropdown from "./InputWithDropdown";

export const FormulaTable = ({
  Form_Key,
  tableData,
  lastModified,
  setLastModified,
  Formula,
  setFormula,
  isFirstLoad,
  setFirstLoad,
  InvoiceType,
  FormData,
  selectedOption,
  setSelectedOption,
}) => {
  const FormDataFromRedux = useSelector((store) => store?.FormDataReducer);
  const MasterData = useSelector((store) => store?.FormDataReducer?.MasterData?.[Form_Key]);
  const dispatch = useDispatch();
  const [valueAndUnit, setValueAndUnit] = useState({ value: "", unit: "₹" });
  const options = ["₹", "%"];

  // useEffect(() => {
  //   let obj = { Name: "Discount", Transaction_Type: "Dr", Amount: "" };
  //   if (valueAndUnit?.value) {
  //     if (valueAndUnit?.unit === "₹" && valueAndUnit?.value) {
  //       obj.Amount = valueAndUnit?.value;
  //     } else if (valueAndUnit?.unit === "%" && valueAndUnit?.value) {
  //       let total = getItemAmount(tableData);
  //       let percentage = (valueAndUnit?.value / 100) * total;
  //       obj.Amount = percentage;
  //     }
  //     setFormula([obj, ...Formula]);
  //   }
  // }, [valueAndUnit?.value]);
  useEffect(() => {
    async function processData(masterData) {
      let arr = [];
      const CommonTaxGroup = FormDataFromRedux?.MasterData[Form_Key]?.Tax_Group; //
      let itemTotalAmount =
        FormData?.Load_Type === "Booking (Broker)" && (Form_Key == "LMS_Sales_Bill" || Form_Key == "Sales_Return")
          ? getBookingTotalAmount(tableData)
          : Form_Key == "LMS_Sales_Bill" || Form_Key == "Sales_Return"
          ? getCNTotalAmount(tableData)
          : getItemAmount(tableData);

      if (CommonTaxGroup?._id) {
        let updatedData = CalculateTaxForCommonTax(
          CommonTaxGroup?.Selected_Taxes,
          itemTotalAmount,
          InvoiceType,
          FormData
        );
        arr = updatedData;
      } else if (FormData?.Tax === "Common") {
        setFormula([]);
      } else if (Form_Key != "LMS_Sales_Bill" && Form_Key != "Sales_Return") {
        let regularItems = [];

        let AllSum = itemTotalAmount;

        // console.log(tableData, "tableDatatableData1");
        for (const key of Object.keys(tableData)) {
          // console.log(regularItems);
          const Amount = tableData[key].find((el) => el.name === "Amount");
          for (const item of tableData[key]) {
            if (item.name?.includes("Tax_Group") && item.value) {
              // console.log(item, key, masterData);
              const Tax_Group = masterData?.[key]?.[item.name];
              const updatedData = CalculateTaxForCommonTax(
                Tax_Group?.Selected_Taxes,
                Amount.value,
                InvoiceType,
                FormData
              );
              // console.log(updatedData);

              console.log(item, Amount, updatedData);
              updatedData.forEach((newItem) => {
                const existingRegularIndex = regularItems.findIndex(
                  (el) => el.Rate === newItem.Rate && el.Name === newItem.Name
                );

                // console.log(newItem, "newItem", existingRegularIndex);

                if (existingRegularIndex !== -1) {
                  // console.log(newItem, "AllSum", regularItems[existingRegularIndex]);

                  regularItems[existingRegularIndex].Amount = Addition(
                    regularItems[existingRegularIndex].Amount,
                    newItem.Amount
                  );
                  regularItems[existingRegularIndex].Transaction_Type =
                    regularItems[existingRegularIndex].Transaction_Type || newItem.Transaction_Type;
                  AllSum = Addition(AllSum, newItem.Amount);
                  // console.log(newItem, "AllSum", regularItems[existingRegularIndex]);
                } else {
                  // console.log(newItem);
                  regularItems.push(newItem);
                  AllSum = Addition(AllSum, newItem.Amount);
                  // console.log(AllSum, "AllSum", 4, newItem.Amount);
                }
                // }
              });
            }
          }
        }

        // Finally, concatenate the special items to the end of the regular items array
        arr = [...regularItems];
      }

      let billTotal = BillTotal([
        {
          Amount: itemTotalAmount,
        },
        ...arr,
      ]);
      let per = ((Number(MasterData["TDSTCS"]?.Tax_Percentage) / 100) * Number(billTotal)).toFixed(2) || 0;
      if (Form_Key === "Purchase_Bill" || Form_Key === "Vendor_Freight_Bill") {
        setSelectedOption((prev) => {
          return {
            ...prev,
            TDSTCSRate: MasterData?.["TDSTCS"]?.Tax_Percentage,
            TDSTCSAmount: Number.isFinite(Number(per)) ? Number(per) : 0,
          };
        });
      }
      console.log(Subtraction(billTotal, per), billTotal, per);
      if (arr.length) {
        setFormula([
          {
            Name: "Taxable Amount",
            Amount: itemTotalAmount,
          },
          ...arr,
          {
            Name: "Total",
            // Amount: billTotal || 0,
            Amount:
              Form_Key === "Purchase_Bill" || Form_Key === "Vendor_Freight_Bill"
                ? Subtraction(billTotal, per) || billTotal || 0
                : billTotal || 0,
            Transaction_Type: InvoiceType === "Sales" ? "Dr" : InvoiceType === "Purchase" ? "Cr" : "",
            Calculation_Type: "Total",
          },
        ]);
      }
    }
    const isRelevantFieldModified =
      ["Tax_Group", "Item_Value", "Quantity", "Amount", "Stock_Item"].includes(lastModified.fieldName) ||
      lastModified.fieldName.includes("HSN") ||
      Form_Key == "LMS_Sales_Bill";

    if (isRelevantFieldModified && FormData?.Party && isFirstLoad) {
      const masterData = FormDataFromRedux?.MasterData[Form_Key];
      processData(masterData);
    }
  }, [
    lastModified,
    FormData?.Tax_Group,
    FormData?.Party,
    FormDataFromRedux?.MasterData[Form_Key],
    tableData,
    FormData?.RCM,
    FormData?.Tax,
  ]);

  const handleChange = (event) => {
    setSelectedOption((prev) => {
      return { ...prev, TDSTCSData: "" };
    });
    if (MasterData && MasterData["TDSTCS"]) {
      dispatch({
        type: "StoreMasterData",
        payload: {
          Form_Key,
          data: { ["TDSTCS"]: "" },
        },
      });
    }

    setSelectedOption({
      TDSTCSData: "",
      TDSTCSAmount: "",
      TDSTCSRate: "",
      selectedRadioOption: event.target.value,
    });
  };
  const handleTDSTCS = (e) => {
    setFirstLoad(true);
    if (e.target.value) {
      setSelectedOption((prev) => {
        return { ...prev, TDSTCSData: e.target.value };
      });
    } else if (e.target.value === "") {
      setSelectedOption((prev) => ({
        ...prev,
        TDSTCSData: "",
        TDSTCSRate: "",
        TDSTCSAmount: "",
      }));
    }
  };

  return (
    <>
      {Formula?.length ? (
        <table className="salesBillTable ">
          <thead>
            <tr>
              <th>Name</th>
              <th>Cr/Dr</th>
              <th>Rate</th>
              <th>Amount</th>
            </tr>
          </thead>
          <tbody>
            {/* <tr>
              <td>Discount</td>
              <td className="discount-cell">
                <InputWithDropdown options={options} valueAndUnit={valueAndUnit} setValueAndUnit={setValueAndUnit} />
              </td>
              <td></td>
              <td></td>
            </tr> */}
            {Formula?.map((el, i) => {
              if (el.name === "Discount") return;
              if (el.Name === "Total") {
                return (
                  <>
                    {(Form_Key === "Purchase_Bill" || Form_Key === "Vendor_Freight_Bill") && (
                      <tr>
                        <td>
                          {/* <input
                            type="radio"
                            id="inputText"
                            value={"TDSMaster"}
                            checked={selectedOption?.selectedRadioOption === "TDSMaster"}
                            onChange={handleChange}
                          /> */}
                          <label htmlFor="inputText">TDS</label>
                          {/* <input
                            type="radio"
                            id="inputText"
                            value={"TCSMaster"}
                            checked={selectedOption?.selectedRadioOption === "TCSMaster"}
                            onChange={handleChange}
                          />
                          <label htmlFor="inputText">TCS</label> */}
                        </td>
                        <td className="table-container-input-dropdown">
                          <Input
                            EMTQuery=""
                            checked={""}
                            InputConfig={{
                              masterName: selectedOption?.selectedRadioOption,
                            }}
                            value={selectedOption?.TDSTCSData}
                            type="InputDropForQuery"
                            name="TDSTCS"
                            handleBlur={() => {}}
                            label={"No Label"}
                            modalform={true}
                            Iconinside={true}
                            transactions={true}
                            TypeOfPortal={""}
                            handleInputChange={(e) => {
                              handleTDSTCS(e);
                            }}
                            Tax_Type={true}
                            formkey={Form_Key}
                          />
                        </td>
                        <td className="numberColumn">{selectedOption?.TDSTCSRate}</td>
                        <td>{selectedOption?.TDSTCSAmount}</td>
                      </tr>
                    )}
                    <SalesBillFormulaTable el={el} index={i} handleDelete={() => {}} handleFormulaChange={() => {}} />
                  </>
                );
              }
              return <SalesBillFormulaTable el={el} index={i} handleDelete={() => {}} handleFormulaChange={() => {}} />;
            })}
          </tbody>
        </table>
      ) : (
        ""
      )}
    </>
  );
};
